const KEY = 'wapharma_v2_token';
const LEGACY_KEY = 'wapharma_v2_refresh';
/** Cross-tab signal — localStorage so other tabs get `storage` events. */
const AUTH_SYNC_KEY = 'wapharma_v2_auth_sync';

function migrateLegacyTokensOnce(): void {
  if (typeof localStorage === 'undefined' || typeof sessionStorage === 'undefined') return;
  const legacyAccess = localStorage.getItem(KEY);
  const legacyRefresh = localStorage.getItem(LEGACY_KEY);
  if (!legacyAccess && !legacyRefresh) return;
  if (legacyAccess && !sessionStorage.getItem(KEY)) {
    sessionStorage.setItem(KEY, legacyAccess);
  }
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
}

migrateLegacyTokensOnce();

export function getToken(): string | null {
  return sessionStorage.getItem(KEY);
}

export function setAccessToken(access: string) {
  sessionStorage.setItem(KEY, access);
}

/** @deprecated refresh token lives in httpOnly cookie — kept for call-site compat */
export function setTokens(access: string, _refresh?: string) {
  setAccessToken(access);
}

export function setToken(t: string) {
  setAccessToken(t);
}

export function clearTokens() {
  sessionStorage.removeItem(KEY);
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
}

/**
 * Clear access token only if it is still the one that failed.
 * Prevents late 401 handlers (pre-login / pre-reset) from wiping a fresh session.
 */
export function clearTokensIfCurrent(failedAccessToken: string | null | undefined): boolean {
  if (failedAccessToken == null || failedAccessToken === '') return false;
  if (getToken() !== failedAccessToken) return false;
  clearTokens();
  return true;
}

/** Tell other same-origin tabs that this tab logged out. */
export function broadcastAuthLogout(): void {
  try {
    localStorage.setItem(AUTH_SYNC_KEY, JSON.stringify({ type: 'logout', at: Date.now() }));
  } catch {
    /* private mode / quota */
  }
}

/**
 * Listen for logout from other tabs (`storage` fires only in *other* documents).
 * Returns unsubscribe.
 */
export function subscribeAuthLogout(onLogout: () => void): () => void {
  const handler = (e: StorageEvent) => {
    if (e.storageArea != null && e.storageArea !== localStorage) return;
    if (e.key !== AUTH_SYNC_KEY || e.newValue == null) return;
    try {
      const payload = JSON.parse(e.newValue) as { type?: string };
      if (payload.type === 'logout') onLogout();
    } catch {
      /* ignore malformed */
    }
  };
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}
